import { render } from "./NewsForm.vue?vue&type=template&id=7edc4fd3&scoped=true"
import script from "./NewsForm.vue?vue&type=script&lang=js"
export * from "./NewsForm.vue?vue&type=script&lang=js"

import "./NewsForm.vue?vue&type=style&index=0&id=7edc4fd3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edc4fd3"]])

export default __exports__